import { useState } from 'react'
import cutileiApi from 'services/cutileiApi'
import AuthService from 'services/auth'
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@cutilei/ui'
import CheckBox from 'components/CheckBox'
import { ReactComponent as ButtonLoading } from 'icons/loading.svg'

import {
  Container,
  Row,
  Column,
  SubTitle,
  InfoText,
  Button,
  ProfessionalsGrid,
  ProfessionalBlock,
  ProfessionalPicture,
  ButtonText
} from './styles'

export default function ImportServicesModal ({
  visible,
  professionals = [],
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const [loading, setLoading] = useState (false)
  const [selectedProfessional, setSelectedProfessional] = useState (null)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const getProfessionalServices = async () => {
    if (!selectedProfessional) return

    try {
      setLoading (true)
      const professionalId = selectedProfessional?.id
      const filters = 'status=active'

      const { data: services } = await cutileiApi.get (
        `/businesses/${businessId}/professionals/${professionalId}/services?${filters}`,
        requestConfig
      )

      const { data: servicesCategories } = await cutileiApi.get (
        `/businesses/${businessId}/professionals/${professionalId}/service_categories?${filters}`,
        requestConfig
      )
      
      setLoading (false)
      handleConfirm (services, servicesCategories)
      handleClose ()
    } catch (error) {
      setLoading (false)
      console.error (error)
    }
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Importar serviços</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Container>
            <InfoText>
              Selecione o profissional do qual deseja importar os serviços e as categorias de serviço.
            </InfoText>
            <Column>
              <ProfessionalsGrid>
                {professionals.map ((professional, index) => (
                  <ProfessionalBlock
                    key={index}
                    onClick={() => setSelectedProfessional (professional)}
                    style={{margin: 0}}
                  >
                    <Column>
                      <Row style={{position: 'relative', marginBottom: 3}}>
                        <CheckBox
                          id={professional.id}
                          style={{position: 'absolute', top: 7, left: 7}}
                          value={selectedProfessional?.id === professional.id}
                          onValueChange={setSelectedProfessional}
                        />
                        <ProfessionalPicture
                          src={professional.profile_picture}
                          selected={selectedProfessional?.id === professional.id}
                        />
                      </Row>
                      <SubTitle>
                        {professional.nickname}
                      </SubTitle>
                    </Column>
                  </ProfessionalBlock>
                ))}
              </ProfessionalsGrid>
            </Column>
          </Container>
        </DialogBody>
        <DialogFooter>
          <Row>
            <Button type='submit' onClick={getProfessionalServices}>
              <ButtonText>
                {loading ? <ButtonLoading/> : 'Confirmar'}
              </ButtonText>
            </Button> 
          </Row>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
